import { Alert, Snackbar } from "@mui/material";

const CustomSnackbar = ({
  message,
  setMessage,
  severity, // success, info, warning, or error
  top = "7px",
  autoHideTime = null,
}) => {
  const handleClose = () => {
    if (typeof message === "string") {
      setMessage("");
    } else if (typeof message === "object") {
      setMessage({
        message: "",
        severity: "",
      });
    }
  };

  return (
    <Snackbar
      open={message}
      autoHideDuration={autoHideTime}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        "&.MuiSnackbar-root": { top: top },
      }}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
